import React from 'react';

const MatchGameContext = React.createContext({});

export const MatchGameContextProvider = MatchGameContext.Provider;
export const MatchGameContextConsumer = MatchGameContext.Consumer;

export default MatchGameContext;
